import SafelySetInnerHTML from 'safely-set-inner-html'

const safelySetInnerHTML = new SafelySetInnerHTML({
	ALLOWED_TAGS: ['strong'],
	ALLOWED_ATTRIBUTES: [],
})

export default safelySetInnerHTML.transform
